var colorbrewer = require('colorbrewer');
var d3 = require('d3');
var moment = require('moment');

var Bandwidth = require('../../util/Bandwidth');

var colourSet = ["#F26C5C","#FDB913","#4daf4a"];

function Line(el, options) {
    this.el = el;
    this.options = options || {};

    this.line = d3.svg.line()
        .x(function (d) { return this.xScale(d.date); }.bind(this))
        .y(function (d) { return this.yScale(d.value); }.bind(this));

    this.xScale = d3.time.scale()
        .range([0, this.getWidth()]);
    this.xAxis = d3.svg.axis()
        .scale(this.xScale)
        .orient("bottom")
        .tickFormat(d3.time.format('%b'));
    this.xBisector = d3.bisector(function (d) { return d.date; }).left;

    this.yScale = d3.scale.linear()
        .range([this.getHeight(), 0]);
    this.yAxis = d3.svg.axis()
        .scale(this.yScale)
        .orient("left")
        .tickFormat(Bandwidth.format);

    var margins = this.getMargins();
    this.chart = d3.select(this.el)
        .append('svg')
            .attr("width", this.options.width)
            .attr("height", this.options.height)
        .append("g")
            .attr('class', 'container')
            .attr("transform", "translate(" + margins.left + "," + margins.top + ")");

    this.chart.append("g")
        .attr("class", "series");
    this.chart.append("g")
        .attr("class", "baselines");

    this.chart.append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0, " + this.getHeight() + ")")
        .call(this.xAxis);

    this.chart.append("g")
        .attr("class", "y axis")
        .call(this.yAxis);

    this.focus = this.chart.append("g")
        .attr("class", "focus")
        .style("display", "none");
    this.focus.append("line")
        .attr("class", "x")
        .style("stroke", "blue")
        .style("stroke-dasharray", "3,3")
        .style("opacity", 0.5)
        .attr("y1", 0)
        .attr("y2", this.getHeight());

    this.tooltip = this.chart.append('g')
        .attr("class", "tooltip-container")
        .attr("transform", "translate(5, 0)")
        .style("display", "none");
    this.tooltip.append("rect")
        .attr("class", "tooltip-background");
    this.tooltip.append("g")
        .attr("class", "tooltips");

    var legendContainer = this.chart.append("g")
        .attr("class", "legend-container")
        .attr("transform", "translate(5, 5)");
    legendContainer.append("rect")
        .attr("class", "legend-background");
    legendContainer.append('g')
        .attr('class', 'legends')
        .attr('transform', 'translate(5, 5)');

    this.chart.append("rect")
        .attr("class", "mouse-container")
        .attr("width", this.getWidth())
        .attr("height", this.getHeight())
        .style("fill", "none")
        .style("pointer-events", "all")
        .on("mouseover", this._handleMouseOver.bind(this))
        .on("mouseout", this._handleMouseOut.bind(this));
}

Line.prototype.getMargins = function () {
    return { top: 20, right: 20, bottom: 30, left: 50 };
};

Line.prototype.getWidth = function () {
    var margin = this.getMargins();

    return this.options.width - margin.left - margin.right
};

Line.prototype.getHeight = function () {
    var margin = this.getMargins();

    return this.options.height - margin.top - margin.bottom;
};

Line.prototype.update = function (data, baselines) {
    this._updateAxisExtent(data, baselines);
    this._updateBaselines(baselines);
    this._updateSeries(data);
    this._updateFocus(data);
    this._updateLegends(data);
};

Line.prototype.updateSize = function (width, height) {
    this.options.width = width;
    this.options.height = height;

    this.xScale.range([0, this.getWidth()]);
    this.yScale.range([this.getHeight(), 0]);

    d3.select(this.el).select('svg')
        .attr("width", this.options.width)
        .attr("height", this.options.height);

    this.chart.select(".x.axis")
        .attr("transform", "translate(0, " + this.getHeight() + ")");

    this.chart.select(".mouse-container")
        .attr("width", this.getWidth())
        .attr("height", this.getHeight());
};

Line.prototype._handleMouseMove = function (data, el) {
    var series = data[0];
    var xPos = d3.mouse(el)[0];
    var xDate = this.xScale.invert(xPos);
    var dataPos = this.xBisector(series['values'], xDate, 1);

    if (dataPos >= series.values.length) {
        // This can happen in Chrome with the right edge of the graph
        dataPos = series.values.length - 1;
    }

    this.focus.attr("transform", function () {
        var val = series.values[dataPos];

        return "translate(" + (val ? this.xScale(val.date) : 0) + ", 0)";
    }.bind(this));
    this.focus.selectAll('circle').attr("transform", function (d) {
        var val = d.values[dataPos];

        return "translate(0, " + (val ? this.yScale(d.values[dataPos].value) : 0) + ")";
    }.bind(this));

    var tooltipData = data.map(function (row) {
        return row.name + ": " + (row.values[dataPos] ? Bandwidth.format(row.values[dataPos].value, 2) : "0MB");
    });
    tooltipData.unshift(moment(series.values[dataPos].date).format(_DATE_FORMAT));

    var tooltips = this.tooltip.select(".tooltips")
        .selectAll('.charttooltip')
        .data(tooltipData);
    tooltips
        .text(function (d) { return d; })
        .enter()
        .append('text')
            .attr("class", "charttooltip")
            .attr("transform", function (d, i) { return 'translate(0, ' + i*13 + ')'; })
            .text(function (d) { return d; });
};

Line.prototype._handleMouseOut = function () {
    this.focus.style("display", "none");
    this.tooltip.style("display", "none");
};

Line.prototype._handleMouseOver = function () {
    this.focus.style("display", null);
    this.tooltip.style("display", null);
};

Line.prototype._updateAxisExtent = function (data, baselines) {
    this.xScale.domain(d3.extent(data[0]['values'], function (d) { return d.date; }));
    this.chart.selectAll('.x.axis')
        .call(this.xAxis);

    var yMax = d3.max([
        d3.max(data, function (d) { return d3.max(d.values, function(d) { return d.value; }); }),
        d3.max(baselines, function (d) { return d.value; })
    ]);
    this.yScale.domain([0, yMax * 1.1]);
    this.chart.selectAll('.y.axis')
        .call(this.yAxis);
};

Line.prototype._updateBaselines = function (baselines) {
    var baseSeries = this.chart.select(".baselines")
        .selectAll('line')
        .data(baselines);

    baseSeries.enter()
        .append('line')
            .attr('class', 'line');

    var xRange = this.xScale.range();
    baseSeries
        .attr('stroke', function (d, i) { return colorbrewer.BrBG[4][i] })
        .attr("x1", function () { return xRange[0]; })
        .attr("x2", function () { return xRange[1]; })
        .attr("y1", function (d) { return this.yScale(d.value); }.bind(this))
        .attr("y2", function (d) { return this.yScale(d.value); }.bind(this))
        .attr("name", function (d) { return d.name; });
};

Line.prototype._updateFocus = function (data) {
    var handleMouseMove = this._handleMouseMove.bind(this);
    this.chart.select(".mouse-container").on("mousemove", function () {
        handleMouseMove(data, this);
    });

    this.focus.selectAll(".xhair")
        .data(data)
        .enter()
        .append("circle")
            .attr("class", "xhair")
            .style("fill", "none")
            .style("stroke", "blue")
            .attr("r", 4);
};

Line.prototype._updateLegends = function () {
    var namedData = this.chart.selectAll('.line')[0];

    var container = this.chart.select('.legends');
    var legends = container.selectAll('.legend')
        .data(namedData);

    var legend = legends.enter()
        .append('g')
            .attr('class', 'legend')
            .attr('transform', function (d, i) { return 'translate(0,'+i*13+')'; });

    legend.append('rect')
        .attr('width', 10)
        .attr('height', 10)
        .attr('fill', function (d) { return d.getAttribute('stroke'); });
    legend.append('text')
        .attr('x', 13)
        .attr('y', 9)
        .text(function (d) { return d.getAttribute('name'); });

    var legendBbox = container.node().getBBox();
    this.chart.select('.legend-background')
        .attr('width', legendBbox.width + 10)
        .attr('height', legendBbox.height + 6);

    this.chart.select(".tooltip-container")
        .attr("transform", "translate(5, " + (legendBbox.height + 26) + ")");
};

Line.prototype._updateSeries = function (seriesData) {
    var series = this.chart.select(".series")
        .selectAll('path')
        .data(seriesData);

    series.enter()
        .append('path')
            .attr('class', 'line');

    series
        .attr('stroke', function (d, i) { return colourSet[i]; })
        .attr('d', function (d) { return this.line(d.values) }.bind(this))
        .attr('name', function (d) { return d.name; });
};

module.exports = Line;



// WEBPACK FOOTER //
// ./app/components/Chart/LineD3.js